<div class="card shadow">

  <div ngbDropdown class="btn-toggle text-primary border rounded" placement="bottom-right">
    <button type="button" class="btn" id="gameCardDropdown" ngbDropdownToggle>
      <i class="fa fa-ellipsis-h"></i>
    </button>
    <div ngbDropdownMenu aria-labelledby="gameCardDropdown" class="mt-1">
      <button ngbDropdownItem (click)="editGame()">
        {{ "Edit" | translate }}
      </button>
      <button ngbDropdownItem (click)="onToggleActive.emit(game)">
        {{ (game?.active ? "Deactivate" : "Activate") | translate }}
      </button>
      <button ngbDropdownItem class="text-danger" (click)="onDelete.emit(game)">
        {{ "Delete" | translate }}
      </button>
    </div>
  </div>

  <img [src]="gameImg" class="card-img-top" width="100%" height="130" style="object-fit: cover;" />

  <div class="card-body position-relative">
    <span
      class="badge rounded-pill p-2 px-3 text-white position-absolute fw-normal"
      [ngClass]="game?.active ? 'bg-success' : 'bg-secondary'"
    >
      {{ game?.type | titlecase }}
    </span>

    <h3 class="card-title mb-2 mt-2 fw-normal short-name">
      {{ displayName }}
    </h3>

    <p class="card-text short-description">
      {{ displayDescription }}
    </p>

    <div class="d-flex justify-content-start align-items-center" style="min-height: 21px">
      <span class="text-muted" style="font-size: 13px;">
        <i class="fa fa-tag me-1"></i>
        {{ game?.price ? ('€' + game?.price) : ('Free' | translate) }}
      </span>
    </div>
  </div>
</div>
